var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { css } from '@patternfly/react-styles';
import { Button, Icon } from '@patternfly/react-core';
import { TagIcon } from '@patternfly/react-icons';
import { createUseStyles } from 'react-jss';
const useStyles = createUseStyles({
    buttonTagCount: {
        display: 'flex',
        alignItems: 'center',
        padding: 'var(--pf-t--global--spacer--sm) var(--pf-t--global--spacer--md)'
    },
    tagIcon: (isDisabled) => ({
        color: `var(--pf-t--global--icon--color--${isDisabled ? '200' : '100'})`,
    }),
    tagText: {
        marginLeft: 'var(--pf-t--global--spacer--sm)',
        fontSize: 'var(--pf-t--global--font--size--sm)'
    }
});
const TagCount = (_a) => {
    var { count, className, iconSize = 'md', ouiaId = 'TagCount' } = _a, props = __rest(_a, ["count", "className", "iconSize", "ouiaId"]);
    const classes = useStyles(!count);
    const tagClasses = css(classes.buttonTagCount, className);
    return (_jsx(Button, Object.assign({ icon: _jsxs(_Fragment, { children: [_jsx(Icon, { iconSize: iconSize, "data-ouia-component-id": `${ouiaId}-icon`, children: _jsx(TagIcon, { className: classes.tagIcon }) }), _jsx("span", { className: classes.tagText, "data-ouia-component-id": `${ouiaId}-text`, children: count })] }), "aria-label": "Tag count" }, props, { variant: "plain", isDisabled: !count, className: tagClasses, ouiaId: ouiaId })));
};
export default TagCount;
